<p-table
    #table
    [loading]="loadingListNodes"
    [value]="inputListNodes"
    [columns]="listColumns"
    dataKey="id"
    [scrollable]="true"
    scrollHeight="350px"
    [selectionMode]="this.selectionMode"
    [(selection)]="this.selected"
    (onRowUnselect)="unselectNode()"
    (onRowSelect)="selectNode()"
    [ngStyle]="{
        textAlign: 'left'
    }"
     styleClass="p-datatable-striped"
>
    <ng-template pTemplate="caption">
        <input
            type="text"
            pInputText
            placeholder="Search..."
            (input)="table.filterGlobal($event.target.value, 'contains')"
            (keyup.enter)="transferOnEnter()"
            class="search-accounts-input"
            [(ngModel)]="searchValue"
        />
    </ng-template>

    <ng-template pTemplate="header" *ngIf="listColumns && listColumns.length > 1">
        <tr>
            <th *ngFor="let col of listColumns" [style.width]="col.width">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
            <td
                *ngFor="let col of listColumns; let i = index"
                style="word-wrap: break-word"
                [style.width]="col.width"
            >
                {{ rowData[col.field]}}
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="listColumns.length">No data found.</td>
        </tr>
    </ng-template>
</p-table>